// extracted by mini-css-extract-plugin
export var input = "numeric-input-module--input--aI96j";
export var quantityLabel = "numeric-input-module--quantityLabel--sJEDZ";
export var wrap = "numeric-input-module--wrap---fT8G";